export default {"src":"/_next/static/media/icone-potential.836561b6.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};